import { groupBy, reduce, sumBy } from 'lodash';
import * as React from 'react';
import { CartSeat, Seat } from '../../../classes/seat';
import { convertStringToStringList } from '../../../helpers/array-helpers';
import { getCurrencyFormat } from '../../../helpers/currency-format';
import { selectGroupedSeats, selectSeat } from '../../../seatmap/actions/seatmap-actions';
import { removeSeatFromCart, saveSeatRemoval } from '../../../cart/actions/cart-actions';
import LineItem from './line-item';

export interface ICartItemsProps {
    cartSeats: Array<CartSeat>;   
    cartSubtotalLabel: string;
    currencyFormat: string;
    exchangeFreeLabel: string;
}

// List of cart items (LineItem components) and subtotal
class SubtotalItems extends React.Component<ICartItemsProps, { seatToRemove: CartSeat }> {
    render() {

        return (
            <div className="overlay-section-subtotal-content">
                <span>{this.props.cartSubtotalLabel}</span>
                <span className="subtotal">{this.cartSubTotal}</span>
            </div>

        );
    }



    get cartSubTotal(): string {
        const total = reduce(this.props.cartSeats.map(seat => seat.selectedPricing.priceCarted), (sum, n) => sum + n, 0);

        if (total > 0 || this.props.exchangeFreeLabel === "") {
            return getCurrencyFormat(this.props.currencyFormat, total);
        }

        return '$0.00';
    }



}

export default SubtotalItems;